<template>
  <treeselect-component
    :class="{ 'invalid': !isValid }"
    v-on="$listeners"
    v-bind="{ ...$attrs, ...additionalProps }"
  />
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import TreeselectComponent from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

@Component({
  components: {
    TreeselectComponent,
  },
})
export default class Treeselect extends Vue {
  @Prop({ default: true }) public readonly isValid!: boolean
  @Prop({ default: false }) public readonly isStatic!: boolean

  get additionalProps () {
    return (this.isStatic) ? {
      searchable: false,
      clearable: false,
      backspaceRemoves: false,
      deleteRemoves: false,
    } : {}
  }
}
</script>

<style lang="scss" scoped>
.invalid:hover ::v-deep .vue-treeselect__control,
.invalid ::v-deep .vue-treeselect__control {
  border-color: $danger;
  &:hover {
    border-color: $danger;
  }
}
</style>